export default "__VITE_ASSET__BcdGGElR__"